import React, { Component } from 'react';
import { X, Sparkles } from 'lucide-react';
interface Suggestion {
  id: string;
  category: string;
  title: string;
  description: string;
  icon: ComponentType<{
    className?: string;
  }>;
}
interface WidgetAISidebarProps {
  isOpen: boolean;
  onClose: () => void;
  widgetInfo: {
    title: string;
    description: string;
  };
  suggestions: Suggestion[];
}
export const WidgetAISidebar: React.FC<WidgetAISidebarProps> = ({
  isOpen,
  onClose,
  widgetInfo,
  suggestions
}) => {
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-214" />

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-full sm:w-96 md:w-[450px] bg-white shadow-xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isOpen ? 'transform-none' : 'translate-x-full'}`} data-id="element-215">
        <div className="p-6" data-id="element-216">
          {/* Header */}
          <div className="flex items-center justify-between mb-4" data-id="element-217">
            <div data-id="element-218">
              {/* AI Pill */}
              <div className="flex items-center gap-1.5 px-2.5 py-1 bg-greenback/10 rounded-full mb-2 inline-flex" data-id="element-219">
                <Sparkles className="h-3 w-3 text-greenback" data-id="element-220" />
                <span className="text-xs font-semibold text-greenback" data-id="element-221">
                  Suggerimenti AI
                </span>
              </div>
              <h2 className="text-xl font-semibold" data-id="element-222">{widgetInfo.title}</h2>
            </div>
            <button onClick={onClose} className="rounded-full p-2 hover:bg-gray-100 transition-colors" data-id="element-223">
              <X className="h-5 w-5 text-gray-500" data-id="element-224" />
            </button>
          </div>

          <p className="text-sm text-gray-600 mb-6" data-id="element-225">{widgetInfo.description}</p>

          {/* Suggestions */}
          <div className="space-y-4" data-id="element-226">
            {suggestions.map(suggestion => <div key={suggestion.id} className="p-4 border border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition-colors" data-id="element-227">
                <div className="flex items-start" data-id="element-228">
                  <div className="p-2 bg-greenback/10 rounded-lg mr-3" data-id="element-229">
                    <suggestion.icon className="h-5 w-5 text-greenback" data-id="element-230" />
                  </div>
                  <div className="flex-1" data-id="element-231">
                    <div className="flex items-center mb-1" data-id="element-232">
                      <span className="text-xs font-medium px-2 py-0.5 rounded-full mr-2 bg-greenback/10 text-greenback" data-id="element-233">
                        {suggestion.category}
                      </span>
                      <h3 className="text-sm font-medium" data-id="element-234">
                        {suggestion.title}
                      </h3>
                    </div>
                    <p className="text-sm text-gray-600" data-id="element-235">
                      {suggestion.description}
                    </p>
                  </div>
                </div>
                <div className="mt-3 ml-10" data-id="element-236">
                  <div style={{
                background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
                padding: '2px',
                borderRadius: '100px'
              }} data-id="element-237">
                    <button className="text-xs px-3 py-1 bg-white text-black transition-colors hover:bg-gray-50 w-full" style={{
                  borderRadius: '100px'
                }} data-id="element-238">
                      Applica Suggerimento
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </>;
};